import React, { FC } from 'react';
import classNames from 'classnames';

import Button from 'vibo-ui/Button';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useMe } from 'graphql/hooks/user';

import { ReactComponent as ViboLogoIcon } from 'resources/img/svg/viboLogo.svg';
import { ReactComponent as MadeWithIcon } from 'resources/img/svg/madeWith.svg';
import { ReactComponent as Heart } from 'resources/img/svg/Dashboard/MenuIcons/triggerHeart.svg';
import { ReactComponent as MadeWithViboIcon } from 'resources/img/svg/madeWithVibo.svg';
import { ReactComponent as ViboLogoProSmIcon } from 'resources/img/svg/viboLogoProSm.svg';

import { SiderTriggerProps } from './interfaces';

import useStyles from './style';

const SiderExtra: FC<SiderTriggerProps> = ({ isClosed, toggleClose }) => {
  const classes = useStyles();

  const { isPro } = useMe();

  return (
    <div className={classNames('siderExtra', classes.siderExtra)}>
      <Button
        onClick={() => toggleClose(!isClosed)}
        prefixIcon={IconmoonFont[isClosed ? 'caretRight-16' : 'caretLeft-16']}
        className={classes.collapseButton}
      />
      <div
        className={classNames(classes.madeWithLove, {
          closed: isClosed,
          isPro,
        })}
      >
        {!isClosed ? null : (
          <Icon
            icon={isPro ? ViboLogoProSmIcon : ViboLogoIcon}
            className="viboLogoIcon"
            disableAutoFontSize
          />
        )}
        {isClosed ? null : isPro ? (
          <MadeWithViboIcon className={classes.madeWithViboPro} />
        ) : (
          <>
            <MadeWithIcon className={classes.madeWith} />
            <Heart className={classes.viboHeart} />
          </>
        )}
      </div>
    </div>
  );
};

export default SiderExtra;
